module.exports = __webpack_public_path__ + "img/home.ec21d4a4.jpg";